// Central sorting for country/province enumerations fetched from the V2 API.
// Handles both camelCase and PascalCase response shapes without altering item contents.

const titleOf = (item) => item.title ?? item.Title ?? '';

// A-Z by title, with United States pinned to the top.
export const sortCountries = (countries) => {
  if (!Array.isArray(countries)) return countries;
  return [...countries].sort((a, b) => {
    const aIsUS = (a.countryCode ?? a.CountryCode) === 'USA';
    const bIsUS = (b.countryCode ?? b.CountryCode) === 'USA';
    if (aIsUS !== bIsUS) return aIsUS ? -1 : 1;
    return titleOf(a).localeCompare(titleOf(b));
  });
};

// A-Z by title.
export const sortProvinces = (provinces) => {
  if (!Array.isArray(provinces)) return provinces;
  return [...provinces].sort((a, b) => titleOf(a).localeCompare(titleOf(b)));
};
